import { Box, Text } from '@wix/design-system';
import { HintSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { ThemeAwareIcon } from '../../../utils/theme-aware-icon';
import { wdsThemeColors } from '../../../utils/wds-theme-colors';
export const RuleTipItem = _ref => {
  let {
    children,
    dataHook = 'rule-tip-item',
    icon,
    showIcon = true
  } = _ref;
  const shouldShowIcon = showIcon && icon !== null;
  const iconNode = icon === undefined ? /*#__PURE__*/React.createElement(ThemeAwareIcon, {
    color: wdsThemeColors.iconPrimary,
    dataHook: "rule-tip-item-icon",
    height: "18px",
    verticalAlign: "middle",
    width: "18px"
  }, /*#__PURE__*/React.createElement(HintSmall, null)) : icon;
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHook,
    direction: "horizontal",
    gap: "SP2",
    verticalAlign: "middle"
  }, shouldShowIcon && iconNode, /*#__PURE__*/React.createElement(Box, {
    flex: "1"
  }, typeof children === 'string' ? /*#__PURE__*/React.createElement(Text, {
    dataHook: `${dataHook}-text`,
    size: "tiny",
    secondary: true
  }, children) : children));
};
//# sourceMappingURL=rule-tip-item.js.map